import { render, staticRenderFns } from "./infoAgree.vue?vue&type=template&id=27bfe1b9"
import script from "./infoAgree.vue?vue&type=script&lang=js"
export * from "./infoAgree.vue?vue&type=script&lang=js"
import style0 from "./infoAgree.vue?vue&type=style&index=0&id=27bfe1b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports